import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import {
  getDefaultBaseSettingsConfigFormly,
  getMixpanelAnalyticsToggleConfig,
} from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  customFileUploadFieldParseIntoSettingsFormModel,
  customFileUploadFieldUpdateFromSettingsFormModel,
  defaultcustomFileUploadConfigFormModel,
} from '../custom-file-upload-field-type.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CustomFileUploadFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: any, field: any) {
    super(injector, field);

    this.settingsFormlyModel = defaultcustomFileUploadConfigFormModel;
    this.settingsFormlyForm = [
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      ...getMixpanelAnalyticsToggleConfig(),
    ];
    this.availableValidations.push('fileSize', 'fileFormats');
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return customFileUploadFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return customFileUploadFieldUpdateFromSettingsFormModel(model, this.field);
  }
}
